<template>
  <div>
    <div v-if="accounts.length" class="activity-table-wrap">
      <table class="activity-table">
        <thead>
          <tr>
            <th>Business</th>
            <th>Owner</th>
            <th>Last active</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="account in accounts.slice(0, limit)" :key="account.id">
            <td><strong>{{ account.name || 'Unnamed business' }}</strong></td>
            <td><span>{{ account.owner_name || account.owner_email || 'Unknown' }}</span></td>
            <td>
              <span
                class="activity-time"
                :class="mode"
                :title="formatExactActivity(account.last_active)"
              >
                {{ formatActivity(account.last_active) }}
              </span>
            </td>
            <td>
              <button
                type="button"
                class="row-action"
                :aria-label="`Open ${account.name || 'business'}`"
                @click="$emit('open', account.id)"
              >
                →
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="empty-state compact">No account activity is available.</div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'AdminActivityTable',
  props: {
    accounts: {
      type: Array,
      default: () => []
    },
    mode: {
      type: String,
      default: 'active'
    },
    limit: {
      type: Number,
      default: 6
    }
  },
  methods: {
    hasActivity(value) {
      return Boolean(value) && Number.isFinite(new Date(value).getTime()) && new Date(value).getTime() > 0
    },
    formatActivity(value) {
      return this.hasActivity(value) ? moment(value).fromNow() : 'Never active'
    },
    formatExactActivity(value) {
      return this.hasActivity(value) ? moment(value).format('MMM D, YYYY [at] HH:mm') : 'Never active'
    }
  }
}
</script>
